module.exports = __webpack_public_path__ + "img/0036F50C-12B2-4457-8EBD-8BC3F0517AAC.106e7645.svg";